import React from 'react';
import { Row, Col, Container, Carousel } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import UspStrip from '../components/UspStrip';
import Footer from '../components/Footer';
import { GET_PRODUCTS } from '../graphql/operations';
import banner from '../assets/banner.jpg';
import flyer from '../assets/Flyers-Brochures.jpg';
import wedding from '../assets/Wedding-Invitations.jpg';
import flex from '../assets/flex-printing.jpg';
import visiting from '../assets/Visiting-Cards.jpg';
import wall from '../assets/wall-poster.jpg';
import stickers from '../assets/Stickers-Labels.jpg';
import posters from '../assets/Posters.jpg';
import idcards from '../assets/ID-Cards.jpg';
import certificates from '../assets/Certificates.jpg';
import photoFrames from '../assets/photo-frames.png';
import backlightBoard from '../assets/boards/backlight.png';
import tBoard from '../assets/boards/tboard.png';
import aBoard from '../assets/boards/aboard.png';

// Importing portfolio banner assets
import banner1 from '../assets/banner/banner_1.jpg';
import banner2 from '../assets/banner/banner_2.jpg';
import banner3 from '../assets/banner/banner_3.jpg';
import banner4 from '../assets/banner/banner_4.jpg';
import banner5 from '../assets/banner/banner_5.jpg';
import banner6 from '../assets/banner/banner_6.jpg';
import banner7 from '../assets/banner/banner_7.jpg';
import banner8 from '../assets/banner/banner_8.jpg';

// Importing portfolio visiting card assets
import card1 from '../assets/visiting cards/card_1.jpg';
import card2 from '../assets/visiting cards/card_2.jpeg';

// Importing portfolio flyer assets
import flyer1 from '../assets/Flyers & Brochures/flyer1.jpeg';
import flyer2 from '../assets/Flyers & Brochures/flyer2.jpeg';
import flyer3 from '../assets/Flyers & Brochures/flyer3.jpeg';

// Importing portfolio wedding invite assets
import wedding1 from '../assets/wedding/a3 - 001 copy.jpg';
import wedding2 from '../assets/wedding/a3 - 002 copy.jpg';
import wedding3 from '../assets/wedding/cover - 001 copy 2.jpg';
import wedding4 from '../assets/wedding/wedding_card_4.jpeg';
import wedding5 from '../assets/wedding/wedding_card_5.jpeg';
import wedding6 from '../assets/wedding/wedding_card_6.jpeg';
import wedding7 from '../assets/wedding/wedding_card_7.jpeg';
import wedding8 from '../assets/wedding/wedding_card_8.jpeg';
import wedding9 from '../assets/wedding/wedding_card_9.jpeg';
import wedding10 from '../assets/wedding/wedding_card_10.jpeg';
import wedding11 from '../assets/wedding/wedding_card_11.jpeg';

// Importing portfolio sticker assets
import sticker1 from '../assets/stickers/10 X 3 Flex.jpg';
import sticker2 from '../assets/stickers/2 X 4 flex copy.jpg';
import sticker3 from '../assets/stickers/8 X 3 Flex.jpg';
import sticker4 from '../assets/stickers/sticker 7.jpeg';
import sticker5 from '../assets/stickers/sticker 8.jpeg';
import sticker6 from '../assets/stickers/sticker 9.jpeg';

const productImages: { [key: string]: string } = {
  'Flex Banners': banner,
  'Flyers': flyer,
  'Brochures': flyer,
  'Wedding Invitations': wedding,
  'Flex Printing': flex,
  'Visiting Cards': visiting,
  'Wall Posters': wall,
  'Stickers & Labels': stickers,
  'Posters & Artwork': posters,
  'ID Cards & Badges': idcards,
  'Certificates & Awards': certificates,
  'Photo Frames': photoFrames,
  'BackLight Board': backlightBoard,
  'T-Board': tBoard,
  'A-Board': aBoard,
};

const productPortfolioMap: { [key: string]: string } = {
  'Flex Banners': 'Banners',
  'Flyers': 'Flyers',
  'Brochures': 'Flyers',
  'Wedding Invitations': 'Wedding Invites',
  'Flex Printing': 'Banners',
  'Visiting Cards': 'Visiting Cards',
  'Wall Posters': 'Flyers',
  'Stickers & Labels': 'Stickers & Labels',
  'Posters & Artwork': 'Flyers',
  'ID Cards & Badges': 'Visiting Cards',
  'Certificates & Awards': 'Flyers',
  'Photo Frames': 'Stickers & Labels',
  'BackLight Board': 'Banners',
  'T-Board': 'Banners',
  'A-Board': 'Banners',
};

const getCarouselImages = (productName: string): string[] => {
  const primaryImg = productImages[productName] || banner;
  const category = productPortfolioMap[productName];
  const list: string[] = [primaryImg];

  if (category === 'Banners') {
    list.push(banner1, banner2, banner3, banner4, banner5, banner6, banner7, banner8);
  } else if (category === 'Visiting Cards') {
    list.push(card1, card2);
  } else if (category === 'Flyers') {
    list.push(flyer1, flyer2, flyer3);
  } else if (category === 'Wedding Invites') {
    list.push(wedding1, wedding2, wedding3, wedding4, wedding5, wedding6, wedding7, wedding8, wedding9, wedding10, wedding11);
  } else if (category === 'Stickers & Labels') {
    list.push(sticker1, sticker2, sticker3, sticker4, sticker5, sticker6);
  }
  return list;
};

const ProductsPage: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useQuery(GET_PRODUCTS);

  return (
    <div className="page-fade d-flex flex-column" style={{ minHeight: 'calc(100vh - 68px)' }}>
      <div style={{ flex: 1 }}>
        <div className="breadcrumb-bar">
          <Link to="/">Home</Link> &gt; Products
        </div>
        <div className="portfolio-hero text-center py-5" style={{ background: 'linear-gradient(135deg, #fff5fb 0%, #fdf2f8 50%, #ffffff 100%)', position: 'relative', overflow: 'hidden' }}>
          {/* Decorative background elements */}
          <div style={{
            position: 'absolute',
            top: '-100px',
            right: '-100px',
            width: '300px',
            height: '300px',
            borderRadius: '50%',
            background: 'rgba(233, 30, 140, 0.05)',
            zIndex: 0
          }}></div>
          <div style={{
            position: 'absolute',
            bottom: '-80px',
            left: '-80px',
            width: '250px',
            height: '250px',
            borderRadius: '50%',
            background: 'rgba(59, 91, 219, 0.05)',
            zIndex: 0
          }}></div>

          <Container style={{ position: 'relative', zIndex: 1 }}>
            <h2 className="display-5 fw-bold text-dark" style={{
              letterSpacing: '-0.5px',
              fontSize: 'clamp(28px, 6vw, 48px)',
              marginBottom: '20px',
              fontWeight: 700,
              background: 'linear-gradient(135deg, #1a1a1a 0%, #3b5bdb 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Our <span style={{ background: 'linear-gradient(90deg, #e91e8c, #3b5bdb)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Products</span>
            </h2>
            <div style={{
              width: '70px',
              height: '4px',
              background: 'linear-gradient(90deg, #e91e8c 0%, #3b5bdb 100%)',
              borderRadius: '2px',
              boxShadow: '0 4px 12px rgba(233, 30, 140, 0.3)',
              margin: '0 auto 32px'
            }}></div>
            <p className="lead text-muted mx-auto mb-5" style={{
              maxWidth: '680px',
              fontSize: 'clamp(14px, 2.5vw, 16px)',
              lineHeight: '1.7',
              color: '#555555',
              fontWeight: 500
            }}>
              From stunning flex banners to premium visiting cards — explore our wide range of high-quality printing solutions tailored for your business needs.
            </p>
            {/* <Link
              to="/order"
              className="btn btn-primary-custom fw-bold text-white d-inline-flex align-items-center gap-2"
              style={{ 
                borderRadius: '10px', 
                fontSize: 'clamp(13px, 2.5vw, 15px)',
                textDecoration: 'none',
                padding: '14px 28px',
                background: 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)',
                border: 'none',
                boxShadow: '0 6px 20px rgba(233, 30, 140, 0.35)',
                transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                cursor: 'pointer',
                fontWeight: 700,
                letterSpacing: '0.3px'
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
                (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 28px rgba(233, 30, 140, 0.45)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                (e.currentTarget as HTMLElement).style.boxShadow = '0 6px 20px rgba(233, 30, 140, 0.35)';
              }}
            >
              <i className="fas fa-shopping-cart"></i> Order Now
            </Link> */}
          </Container>
        </div>
        <div style={{ background: 'var(--bg-secondary)', padding: '50px 5%' }}>
          <Container>
            <Row className="g-4">
              {loading ? (
                <Col xs={12} className="text-center py-5">
                  <p className="text-muted">Loading products...</p>
                </Col>
              ) : data?.products?.length ? (
                <>
                  {data.products.map((p: any) => (
                    <Col key={p.productId} xs={12} sm={6} md={4} lg={3}>
                      <div
                        className="product-card"
                        style={{
                          backgroundColor: '#fff',
                          borderRadius: '12px',
                          overflow: 'hidden',
                          cursor: 'pointer',
                          transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
                          display: 'flex',
                          flexDirection: 'column',
                          height: '100%',
                          border: '1px solid #f0f0f0',
                        }}
                        onMouseEnter={(e) => {
                          const el = e.currentTarget;
                          el.style.transform = 'translateY(-8px)';
                          el.style.boxShadow = '0 12px 25px rgba(233, 30, 140, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                          const el = e.currentTarget;
                          el.style.transform = 'translateY(0)';
                          el.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.08)';
                        }}
                        onClick={() => navigate('/portfolio', { state: { category: productPortfolioMap[p.name] || 'Products' } })}
                      >
                        {/* Image Section with Carousel */}
                        <div style={{ position: 'relative', overflow: 'hidden', height: '200px', background: '#f5f5f5' }}>
                          <Carousel
                            interval={3000}
                            controls={true}
                            indicators={true}
                            pause="hover"
                            className="product-card-carousel"
                            style={{ height: '100%' }}
                            onClick={(e) => {
                              const target = e.target as HTMLElement;
                              if (
                                target.closest('.carousel-control-prev') ||
                                target.closest('.carousel-control-next') ||
                                target.closest('.carousel-indicators')
                              ) {
                                e.stopPropagation();
                              }
                            }}
                          >
                            {getCarouselImages(p.name).map((imgUrl, idx) => (
                              <Carousel.Item key={idx} style={{ height: '200px' }}>
                                <img
                                  src={imgUrl}
                                  alt={`${p.name} - slide ${idx + 1}`}
                                  style={{
                                    width: '100%',
                                    height: '200px',
                                    objectFit: 'cover',
                                    transition: 'transform 0.4s ease',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.08)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                  }}
                                />
                              </Carousel.Item>
                            ))}
                          </Carousel>

                          {/* Gradient Overlay */}
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(135deg, rgba(233, 30, 140, 0.1) 0%, rgba(59, 91, 219, 0.1) 100%)',
                            transition: 'opacity 0.3s ease',
                            pointerEvents: 'none',
                            zIndex: 2,
                          }} />

                          {/* Price Badge */}
                          <div style={{
                            position: 'absolute',
                            top: '12px',
                            right: '12px',
                            background: 'linear-gradient(135deg, #e91e8c, #e91e8c)',
                            color: '#fff',
                            padding: '6px 12px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '700',
                            boxShadow: '0 4px 12px rgba(233, 30, 140, 0.3)',
                            pointerEvents: 'none',
                            zIndex: 3,
                          }}>
                            {p.name === 'Flex Banners' && 'Starting From ₹ ' + p.basePrice + ' for above 100 sq.ft'}
                            {p.name !== 'Flex Banners' && 'From ₹ ' + p.basePrice}
                          </div>
                        </div>

                        {/* Content Section */}
                        <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                          <h4 style={{
                            fontSize: 'clamp(15px, 3.5vw, 18px)',
                            fontWeight: '700',
                            marginBottom: '8px',
                            color: '#1a1a1a',
                            letterSpacing: '-0.3px',
                          }}>
                            {p.name}
                          </h4>
                          <p style={{
                            fontSize: '13px',
                            color: '#666',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                            flex: 1,
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                          }}>
                            {p.desc}
                          </p>

                          {/* CTA Button */}
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            padding: '10px 16px',
                            background: 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)',
                            color: '#fff',
                            borderRadius: '8px',
                            fontWeight: '600',
                            fontSize: 'clamp(12px, 2.5vw, 14px)',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer',
                          }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'scale(1.05)';
                              e.currentTarget.style.boxShadow = '0 6px 15px rgba(233, 30, 140, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'scale(1)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          >
                            <span>Explore</span>
                            <i className="fas fa-arrow-right" style={{ fontSize: 'clamp(10px, 2vw, 12px)' }}></i>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                  <Col key="custom-product" xs={12} sm={6} md={4} lg={3}>
                    <div
                      className="product-card"
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        border: '1px solid #f0f0f0',
                      }}
                      onMouseEnter={(e) => {
                        const el = e.currentTarget;
                        el.style.transform = 'translateY(-8px)';
                        el.style.boxShadow = '0 12px 25px rgba(233, 30, 140, 0.15)';
                      }}
                      onMouseLeave={(e) => {
                        const el = e.currentTarget;
                        el.style.transform = 'translateY(0)';
                        el.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.08)';
                      }}
                      onClick={() => navigate('/contact')}
                    >
                      <div style={{ position: 'relative', overflow: 'hidden', height: '200px', background: 'linear-gradient(135deg, #fdf2f8 0%, #fff5fb 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fas fa-pencil-ruler" style={{ fontSize: '64px', color: '#e91e8c', opacity: 0.8 }}></i>
                        <div style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: 'linear-gradient(135deg, rgba(233, 30, 140, 0.1) 0%, rgba(59, 91, 219, 0.1) 100%)',
                          transition: 'opacity 0.3s ease',
                          pointerEvents: 'none',
                          zIndex: 2,
                        }} />
                      </div>
                      <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <h4 style={{
                          fontSize: 'clamp(15px, 3.5vw, 18px)',
                          fontWeight: '700',
                          marginBottom: '8px',
                          color: '#1a1a1a',
                          letterSpacing: '-0.3px',
                        }}>
                          Other Custom Product
                        </h4>
                        <p style={{
                          fontSize: '13px',
                          color: '#666',
                          lineHeight: '1.6',
                          marginBottom: '16px',
                          flex: 1,
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}>
                          Have a unique printing requirement? Contact us for custom sizes, materials, and designs tailored to your needs.
                        </p>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px',
                          padding: '10px 16px',
                          background: 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)',
                          color: '#fff',
                          borderRadius: '8px',
                          fontWeight: '600',
                          fontSize: 'clamp(12px, 2.5vw, 14px)',
                          transition: 'all 0.3s ease',
                          cursor: 'pointer',
                        }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 6px 15px rgba(233, 30, 140, 0.4)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                          }}
                        >
                          <span>Get Quote</span>
                          <i className="fas fa-arrow-right" style={{ fontSize: 'clamp(10px, 2vw, 12px)' }}></i>
                        </div>
                      </div>
                    </div>
                  </Col>
                </>
              ) : (
                <Col xs={12} className="text-center py-5">
                  <p className="text-muted">No products available</p>
                </Col>
              )}
            </Row>
          </Container>
        </div>
      </div>
      <UspStrip />
      <Footer />
    </div>
  );
};

export default ProductsPage;
